import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { NetProfitComparisonChart } from "../charts/NetProfitComparisonChart";
import { useProfitComparison } from "@/hooks/budget/useProfitComparison";

interface ProfitComparisonSectionProps {
  formatCurrency: (amount: number) => string;
}

export const ProfitComparisonSection = ({ formatCurrency }: ProfitComparisonSectionProps) => {
  const [period, setPeriod] = useState<string>("month");
  const { currentPeriod, previousPeriod } = useProfitComparison(period);

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle>Comparaison des Bénéfices</CardTitle>
        <Select value={period} onValueChange={setPeriod}>
          <SelectTrigger className="w-[180px]">
            <SelectValue placeholder="Sélectionner une période" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="day">Par jour</SelectItem>
            <SelectItem value="week">Par semaine</SelectItem>
            <SelectItem value="month">Par mois</SelectItem>
          </SelectContent>
        </Select>
      </CardHeader>
      <CardContent>
        <div className="h-[400px]">
          <NetProfitComparisonChart 
            currentPeriod={currentPeriod}
            previousPeriod={previousPeriod}
            formatCurrency={formatCurrency}
          />
        </div>
      </CardContent>
    </Card>
  );
};